<template>
  <v-card :flat="!product" :class="{'my-5' : product}">
    <v-card-text class="pb-4" :class="{'px-0': !product}">
      <div class="d-flex justify-space-between align-center" :class="{'mb-4' : product}">
        <v-checkbox v-model="product" :label="item.product" hide-details :disabled="disableLineItem" class="mt-0 pt-0 mr-2"></v-checkbox>

        <template v-if="!product">
          <div>{{ item.total | formatPrice }}</div>
        </template>
      </div>

      <template v-if="product">
        <v-text-field v-model="creditAmount" label="Credit Amount" prefix="£" outlined dense hide-details="auto" :disabled="disableLineItem" :error-messages="creditAmountErrors" class="mb-3" @input="$v.creditAmount.$touch()"></v-text-field>

        <div class="d-flex justify-space-between align-center">
          <v-text-field :value="item.price" label="Price" prefix="£" outlined dense disabled hide-details></v-text-field>
          <v-text-field :value="item.quantity" type="number" label="Quantity" outlined dense disabled hide-details class="mx-2"></v-text-field>
          <v-text-field :value="item.total" label="Total" prefix="£" outlined dense disabled hide-details></v-text-field>
        </div>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import { validationMixin } from 'vuelidate';
  import { decimal, minValue, maxValue } from 'vuelidate/lib/validators';
  import { mapGetters } from 'vuex';

  export default {
    mixins: [ validationMixin ],

    validations() {
      return {
        creditAmount: { 
          decimal,
          minValue: minValue(0),
          maxValue: maxValue(this.item.total)     
        }
      }
    },

    props: {
      item: {
        type: Object,
        default: ()=>({})
      },

      value: {
        type: Array,
        default: ()=>([])
      }
    },

    data() {
      return {
        product: false,
        creditAmount: this.item.creditAmount,
      }
    },

    computed: {
      ...mapGetters('creditnotes', ['getLineItems', 'getToggleEditLineItemsDialog']),

      disableLineItem() {
        return this.item.approved || this.item.total === 0;
      },

      creditAmountErrors() {
        const errors = [];
        if (!this.$v.creditAmount.$dirty) return errors;
        !this.$v.creditAmount.decimal && errors.push('Credit amount should be a number');
        !this.$v.creditAmount.minValue && errors.push('Credit amount should not be less than 0');
        !this.$v.creditAmount.maxValue && errors.push('Credit amount cannot exceed total amount');
        return errors;
      }
    },

    watch: {
      product(val) {
        val ? this.add() : this.remove();
      },

      creditAmount() {
        if (this.product) {
          this.update();
        }
      },

      getToggleEditLineItemsDialog: {
        immediate: true,
        handler(val) {
          if (val) {
            if (this.getLineItems.length) {
              const lineItem = this.getLineItems.find(item => {
                return item.adhoc_line_item_id === this.item.adhoc_line_item_id;
              });
  
              if (lineItem) {
                this.product = true;
                this.creditAmount = lineItem.creditAmount;
              }       
            }
          } else {
            this.reset();
          }
        }   
      }
    },

    methods: {
      add() {
        this.value.push({...this.item, creditAmount: this.creditAmount});
      },

      update() {
        const lineItem = this.value.find(val => val.adhoc_line_item_id === this.item.adhoc_line_item_id);

        if (lineItem) {
          lineItem.creditAmount = this.creditAmount;
          this.$emit('input', this.value);
        } 
      },

      remove() {
        this.creditAmount = this.item.total;

        const itemIndex = this.value.findIndex(val => val.adhoc_line_item_id === this.item.adhoc_line_item_id);

        if (itemIndex >= 0) {
          this.value.splice(itemIndex, 1);
          this.$emit('input', this.value);
        }
      },

      reset() {
        this.product = 0;
        this.creditAmount = this.item.creditAmount;
        this.$v.$reset();
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>